// What the whole system says across the top of every screen (STAGE_6 6.7): the vendor has
// it under maintenance, or the vendor is working inside somebody else's session.

import { useQuery } from '@tanstack/react-query';
import { Alert, Button } from 'antd';

import { api } from '@/api/client';
import { displayName, useOptionalUser } from '@/features/auth/authContext';
import { ru } from '@/i18n/ru';

import { LIVE_CONFIG_KEY, stopImpersonating } from './bannerState';

// Maintenance is switched on while people work: the banner catches up within a minute.
const CONFIG_REFRESH_MS = 60_000;

export function SystemBanners() {
  const user = useOptionalUser();
  const config = useQuery({
    queryKey: [LIVE_CONFIG_KEY],
    queryFn: ({ signal }) => api.get('/config', { signal }),
    refetchInterval: CONFIG_REFRESH_MS,
  });
  return (
    <>
      {user?.impersonated_by && (
        <Alert
          banner
          type="warning"
          message={ru.banners.impersonating(displayName(user), user.impersonated_by)}
          action={
            <Button size="small" onClick={stopImpersonating}>
              {ru.banners.stopImpersonating}
            </Button>
          }
        />
      )}
      {config.data?.maintenance && <Alert banner type="error" message={ru.banners.maintenance} />}
    </>
  );
}
